import React from "react"

import { css } from "@emotion/react"

import { NIRVANA_COLORS } from "../config/theme.config"
import { PrimaryText } from "./primaryText.element"

export const InputErrorElement: React.FunctionComponent<
    IInputErrorElementProps
> = props => {
    return (
        <div className={props.className} css={styles.container}>
            <PrimaryText
                typography="caption"
                color={NIRVANA_COLORS.brand.error}
            >
                {props.text}
            </PrimaryText>
        </div>
    )
}

const styles = {
    container: css({
        marginTop: 8,
    }),
}

interface IInputErrorElementProps {
    className?: string
    text: string
}
